var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container user-list"},_vm._l((_vm.users),function(user){return _c('div',{key:user.id},[_c('UserItem',{attrs:{"user":user}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }